import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { HabilEmpresarialProduto, HabilEmpresarialRotina } from 'src/app/models/he-produto';
import { AbstractService } from 'src/app/services/abstract.service';
import { ClassificacaoService } from 'src/app/services/classificacao.service';
import { HabilEmpresarialProdutoService } from 'src/app/services/he-produto.service';
import { HabilEmpresarialRotinaService } from 'src/app/services/he-rotina.service';
import { GenericCadastro } from 'src/app/utilities/generic-cadastro';
import { clone } from 'src/app/utilities/util/clone-utils';
import { FormValidation } from 'src/app/utilities/util/form-validation';

@Component({
  selector: 'habil-cadastro-produto-habil-empresarial',
  templateUrl: './cadastro-produto-habil-empresarial.component.html',
  styleUrls: ['./cadastro-produto-habil-empresarial.component.scss']
})
export class CadastroProdutoHabilEmpresarialComponent extends GenericCadastro<HabilEmpresarialProduto, HabilEmpresarialProdutoService> implements OnInit {

  rotinas: HabilEmpresarialRotina[] = [];
  carregado = false;

  constructor(
    public service: HabilEmpresarialProdutoService,
    public route: ActivatedRoute,
    public router: Router,
    public classificacaoService: ClassificacaoService,
    public rotinaService: HabilEmpresarialRotinaService,
    public confirmationService: ConfirmationService,
    public titleService: Title,
    public messageService: MessageService,
    public breadcrumbService: BreadcrumbService,
  ) {
    super();
    this.breadcrumbService.setItems([
      { label: 'Produtos', routerLink: '/adm/produtos' },
      { label: 'Cadastro - Hábil Empresarial' }
    ]);
  }

  ngOnInit(): void {
    if (this._isDialog) {
      this._loading = true;
      if (this._externalObj != null && this._externalObj != undefined) {
        this.obj = clone(this._externalObj);
        this.id = this.obj.id;
        this.idCampos = (this.id == undefined ? "0" : this.id.toString());
        this._loading = false;
      } else {
        this.obj = this.newObject();
        this.idCampos = (this.id == undefined ? "0" : this.id.toString());
        this.loadAuxObjects();
        this._loading = false;
      }
    } else {
      this.titleService.setTitle('Produto - ' + AbstractService.app);
      super.ngOnInit();
    }
  }

  newObject(): HabilEmpresarialProduto {
    const obj = new HabilEmpresarialProduto();
    return obj;
  }

  doBeforeSave() { }

  doValidate(): boolean {
    this.corrigeAtributos();

    const validation: FormValidation = new FormValidation();
    validation.toValidate = [
      {
        condition: this.obj.nomeProduto != undefined && this.obj.nomeProduto.length > 0,
        message: "O nome é obrigatório!",
      }
    ];
    if (!validation.isValid()) {
      validation.message().forEach((m) => {
        this.messageService.add({
          severity: "warn",
          summary: "Atenção",
          detail: m,
        });
      });
    }
    return validation.isValid();
  }

  private carregaAcessos(): Promise<void> {
    return new Promise((sim, nao) => {
      this.rotinaService.findAll(0, 9999, '').subscribe({
        next: acessos => {
          this.rotinas = [];
          if (acessos) {
            acessos.forEach(a => {
              this.rotinas.push({
                ...a
              })
            });
          }
          sim();
        },
        error: (erro) => this.service.handleError(erro)
      })
    })
  }

  stopLoading(): void {
    this._loading = false;
    if (!this.carregado) {
      this.carregaAcessos().then(() => {
        this.rotinas.sort((a, b) => {
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          return 0;
        });
        this.obj.rotinas.sort((a, b) => {
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          return 0;
        });
        for (const rotina of this.obj.rotinas) {
          this.rotinas = [...this.rotinas.filter(r => r.id != rotina?.id)];
        }
        this.carregado = true;
      })
    }
  }

}
